import React, { useMemo } from 'react';
import { Sequence, useVideoConfig } from 'remotion';
import { SubtitleContainer } from '../subtitle';
import { Caption, EmojiMap, VideoTheme } from '../../types';

interface CaptionLayerContainerProps {
  captions: Caption[];
  currentFrame: number;
  theme: VideoTheme;
  emojiMap: EmojiMap;
}

const CaptionLayerContainer: React.FC<CaptionLayerContainerProps> = React.memo(
  ({ captions, currentFrame, theme, emojiMap }) => {
    const { fps } = useVideoConfig();

    return (
      <>
        {captions?.map((caption, index) => {
          const start = caption?.startTime * fps;
          const duration = (caption?.endTime - caption?.startTime) * fps;

          return (
            <Sequence key={index} from={start} durationInFrames={duration < 0 ? 1 : duration || 1}>
              <SubtitleContainer
                currentFrame={currentFrame}
                theme={theme}
                caption={caption}
                emojiMap={emojiMap}
              />
            </Sequence>
          );
        })}
      </>
    );
  }
);

export default CaptionLayerContainer;
